import { cn } from "@/lib/utils";

interface AuroraProps {
  className?: string;
  /**
   * Color the vignette fades to at the edges. Defaults to the current
   * theme background. Pass an explicit color when Aurora sits on a
   * surface that doesn't follow the theme (e.g. the always-dark auth
   * marketing panel) — otherwise the gradient washes light over dark.
   */
  fadeColor?: string;
}

/**
 * Animated gradient mesh background. Uses CSS keyframes (in index.css)
 * so it costs nothing on the JS side and respects prefers-reduced-motion
 * via the @media rule on the .aurora utility.
 */
export function Aurora({ className, fadeColor }: AuroraProps) {
  const fade = fadeColor ?? "hsl(var(--background))";
  return (
    <div
      aria-hidden
      className={cn(
        "pointer-events-none absolute inset-0 overflow-hidden",
        className,
      )}
    >
      <div className="aurora-blob aurora-blob-1" />
      <div className="aurora-blob aurora-blob-2" />
      <div className="aurora-blob aurora-blob-3" />
      <div
        className="absolute inset-0"
        style={{
          background: `radial-gradient(ellipse at top, transparent 30%, ${fade} 70%)`,
        }}
      />
    </div>
  );
}
